import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SignalWifiStatusbar4BarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"signal_wifi_statusbar_4_bar"}/>
}
